<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Moon Cutters</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<h3 class="books-by-head"><em>Recent Titles by Janet Woods from Severn House</em></h3>
<p class="books-by-text">AMARANTH MOON</p>
<p class="books-by-text">BROKEN JOURNEY</p>
<p class="books-by-text">CINNAMON SKY</p>
<p class="books-by-text">THE COAL GATHERER</p>
<p class="books-by-text">EDGE OF REGRET</p>
<p class="books-by-text">HEARTS OF GOLD</p>
<p class="books-by-text">LADY LIGHTFINGERS</p>
<p class="books-by-text">I’LL GET BY</p>
<p class="books-by-text">MOON CUTTERS</p>
<p class="books-by-text">MORE THAN A PROMISE</p>
<p class="books-by-text">PAPER DOLL</p>
<p class="books-by-text">SALTING THE WOUND</p>
<p class="books-by-text">SECRETS AND LIES</p>
<p class="books-by-text">THE STONECUTTER’S DAUGHTER</p>
<p class="books-by-text">STRAW IN THE WIND</p>
<p class="books-by-text">TALL POPPIES</p>
<p class="books-by-text">WITHOUT REPROACH</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?033246d8